module.exports = __webpack_public_path__ + "62e0348b62d39e2df9d0e613643306ab.png";